import React, { Component } from "react"
import {
    Button,
    Flex,
    Text
} from "@fluentui/react-northstar";
import { v4 as uuid } from "uuid";
import * as AdaptiveCards from "adaptivecards";
import * as moment from 'moment'
import axios from "axios";

import "./New.scss";
import "./TeamTheme.scss";
import {
    ISelectFormData,
    INotificationFormData,
    IFeedbackFormData,
    IAudienceFormData,
} from "./Types"

import { getBaseUrl } from "../../configVariables";
import Select from "./SelectForm";
import NotificationForm from "./NotificationForm"
import FeedbackForm from "./FeedbackForm";
import AudienceForm from "./AudienceForm";
import { CardFactory } from "./Cards/CardFactory";
import { ICard } from "./Cards/ICard";
import { CardType } from "./Cards/CardType";
import { MessageType } from "./Cards/MessageType";
import CongratulationForm from "./CongratulationForm";
import { FeedbackType } from "./Cards/FeedbackType";

export type NewProps = {
    userData: any;
}

export type NewState = {
    version: string;
    userData: any;
    step: number;
    selectForm: ISelectFormData;
    notificationForm: INotificationFormData;
    feedbackForm: IFeedbackFormData;
    audienceForm: IAudienceFormData;
}

var appVersion = process.env.REACT_APP_VERSION ?? "1.0";

export default class New extends Component<NewProps, NewState> {
    cardFactory: CardFactory = new CardFactory();
    card: ICard = this.cardFactory
        .CreateCard(
            MessageType.Notification,
            CardType.Hero,
            this.props.userData
        );

    private defaultState = () => {
        return {
            version: appVersion,
            userData: this.props.userData,
            step: 0,
            selectForm: {
                MessageTypes: [
                    { key: MessageType.Notification, name: MessageType.Notification, header: MessageType.Notification, content: "" },
                    { key: MessageType.Feedback, name: MessageType.Feedback, header: MessageType.Feedback, content: "" }
                ],
                cardTypes: [
                    { key: CardType.Hero, name: CardType.Hero, header: CardType.Hero, content: "" },
                    { key: CardType.Thumbnail, name: CardType.Thumbnail, header: CardType.Thumbnail, content: "" }
                ],
                selectedMessageType: MessageType.Notification,
                selectedCardType: CardType.Hero
            },
            notificationForm: {
                title: "",
                subtitle: "",
                imageLink: "",
                imageLinkError: "",
                summary: "",
                requireConfirmation: false,
                requireConfirmationButton: { id: "confirm", title: "", type: "Action.Submit", data: { submit: "submit.CardConfirm", id: uuid() }, style: "positive" },
                sendMeeting: false,
                meetingsLoading: false,
                meetings: [],
                selectedMeeting: null,
                buttons: [],
                card: ""
            },
            feedbackForm: {
                title: "",
                subtitle: "",
                imageLink: "",
                imageLinkError: "",
                summary: "",
                requireComments: false,
                feedbackType: [
                    { key: FeedbackType.SimpleCompacto, name: FeedbackType.SimpleCompacto, header: FeedbackType.SimpleCompacto, content: "" },
                    { key: FeedbackType.SimpleExtendido, name: FeedbackType.SimpleExtendido, header: FeedbackType.SimpleExtendido, content: "" },
                    { key: FeedbackType.Multiple, name: FeedbackType.Multiple, header: FeedbackType.Multiple, content: "" }
                ],
                selectedFeedbackType: FeedbackType.SimpleCompacto,
                checkboxes: [],
                card: ""
            },
            audienceForm: {
                targetSelected: "users",
                isUsersTargetSelected: true,
                allUsers: [],
                selectedUsers: [],
                usersLoading: false,
                isTeamsTargetSelected: false,
                allTeams: [],
                selectedTeams: [],
                teamsLoading: false,
                isRostersTargetSelected: false,
                allRosters: [],
                selectedRosters: [],
                isAllTargetSelected: false,
                isGroupTargetSelected: false,
                selectedGroup: ""
            }
        }
    };

    state = this.defaultState();

    resetForm = () => {
        this.setState(this.defaultState());
        this.card = this.cardFactory
            .CreateCard(
                MessageType.Notification,
                CardType.Hero,
                this.props.userData
            );
    }

    // Select
    private onSelectedMessageTypeChange = (item: any) => {
        const selectForm: ISelectFormData = this.state.selectForm;
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        const notificationForm: INotificationFormData = this.state.notificationForm;

        selectForm.selectedMessageType = item.key;

        this.card = this.cardFactory
            .CreateCard(
                selectForm.selectedMessageType,
                selectForm.selectedCardType,
                this.state.userData
            );

        if (selectForm.selectedMessageType === MessageType.Notification) {
            notificationForm.card = this.card.defaultCard();
        } else {
            feedbackForm.card = this.card.defaultCard();
        }

        this.setState({
            selectForm: selectForm,
            notificationForm: notificationForm,
            feedbackForm: feedbackForm
        });
    };

    private onSelectedCardTypeChange = (item: any) => {
        const selectForm: ISelectFormData = this.state.selectForm;
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        const notificationForm: INotificationFormData = this.state.notificationForm;

        selectForm.selectedCardType = item.key;

        this.card = this.cardFactory
            .CreateCard(
                selectForm.selectedMessageType,
                selectForm.selectedCardType,
                this.state.userData
            );

        if (selectForm.selectedMessageType === MessageType.Notification) {
            notificationForm.card = this.card.defaultCard();
        } else {
            feedbackForm.card = this.card.defaultCard();
        }

        this.setState({
            selectForm: selectForm,
            notificationForm: notificationForm,
            feedbackForm: feedbackForm
        });
    };
    // Select

    // Hero
    private notificationGetMeetings = () => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.meetingsLoading = true;
        this.updateNotificationFormState(notificationForm);

        axios.get(`${this.state.userData.organization.id}/users/${this.state.userData.profile.id}/events`)
            .then(response => {
                const eventos = response.data

                const notificationForm = this.state.notificationForm;

                notificationForm.meetings = eventos.map((evento: any) => {
                    return {
                        key: evento.id,
                        name: evento.subject,
                        header: evento.subject,
                        content: `${moment.utc(evento.start).local().format("DD/MM/YYYY HH:mm")} - ${moment.utc(evento.end).local().format("DD/MM/YYYY HH:mm")}`
                    }
                });

                notificationForm.meetingsLoading = false;

                this.setState({ notificationForm: notificationForm });
            })
            .catch(error => {
                console.log(error);
            });
    };

    private updateNotificationCard = () => {
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        adaptiveCard.parse(this.state.notificationForm.card);
        const renderedCard = adaptiveCard.render() ?? new HTMLElement();
        const container = document.getElementsByClassName("adaptiveCardContainer")[0].firstChild;
        if (container != null) {
            container.replaceWith(renderedCard);
        } else {
            document.getElementsByClassName("adaptiveCardContainer")[0].appendChild(renderedCard);
        }
    };

    private shouldSetDefaultNotificationCard(notificationForm: INotificationFormData): boolean {
        let showDefaultCard: boolean = (
            !notificationForm.title
            && !notificationForm.subtitle
            && !notificationForm.imageLink
            && !notificationForm.summary
            && !notificationForm.buttons.length
            && !notificationForm.requireConfirmation
            && !notificationForm.selectedMeeting
        );

        return showDefaultCard
    };

    private updateNotificationFormState = (notificationForm: INotificationFormData) => {
        const showDefaultCard: boolean = this.shouldSetDefaultNotificationCard(notificationForm);

        this.setState({
            notificationForm: notificationForm
        }, () => {
            if (showDefaultCard) {
                notificationForm.card = this.card.defaultCard();
            }

            this.updateNotificationCard();
        });
    };

    private validateUrl(url: string) {
        if (!((url === "") || (url.startsWith("https://") || (url.startsWith("data:image/png;base64,")) || (url.startsWith("data:image/jpeg;base64,")) || (url.startsWith("data:image/gif;base64,"))))) {
            return "La URL debe empezar por https://";
        } else {
            return "";
        }
    };

    private onNotificationTitleChanged = (event: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.title = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationSubtitleChanged = (event: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.subtitle = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationImageLinkChanged = (event: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.imageLink = event.target.value;
        notificationForm.imageLinkError = this.validateUrl(notificationForm.imageLink);

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationSummaryChanged = (event: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.summary = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationRequireConfirmationChange = (event: any, checked: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.requireConfirmation = checked.checked;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationRequireConfirmationButtonTextChange = (event: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.requireConfirmationButton.title = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationSendMeetingChange = (event: any, checked: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.sendMeeting = checked.checked;

        if (notificationForm.sendMeeting)
            this.notificationGetMeetings();
        else notificationForm.selectedMeeting = null;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationSelectedMeetingChange = (item: any) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;

        notificationForm.selectedMeeting = item;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationAddButtonClick = () => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        notificationForm.buttons = [...notificationForm.buttons, { id: uuid(), title: "", url: "", type: "Action.OpenUrl" }];

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationDeleteButtonClick = (id: string) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        const indexToRemove: number = notificationForm.buttons.findIndex(button => button.id === id);

        notificationForm.buttons.splice(indexToRemove, 1);

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationButtonTextChanged = (
        event: any,
        id: string
    ) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        const indexToUpdate: number = notificationForm.buttons.findIndex(button => button.id === id);

        notificationForm.buttons[indexToUpdate].title = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };

    private onNotificationButtonUrlChanged = (
        event: any,
        id: string
    ) => {
        const notificationForm: INotificationFormData = this.state.notificationForm;
        const indexToUpdate: number = notificationForm.buttons.findIndex(button => button.id === id);

        notificationForm.buttons[indexToUpdate].url = event.target.value;

        notificationForm.card = this.card.rebuildNotificationCard(notificationForm);
        this.updateNotificationFormState(notificationForm);
    };
    // Hero

    // Feedback
    private updateFeedbackCard = () => {
        const adaptiveCard = new AdaptiveCards.AdaptiveCard();
        adaptiveCard.parse(this.state.feedbackForm.card);
        const renderedCard = adaptiveCard.render() ?? new HTMLElement();
        const container = document.getElementsByClassName("adaptiveCardContainer")[0].firstChild;
        if (container != null) {
            container.replaceWith(renderedCard);
        } else {
            document.getElementsByClassName("adaptiveCardContainer")[0].appendChild(renderedCard);
        }
    };

    private shouldSetDefaultFeedbackCard(feedbackForm: IFeedbackFormData): boolean {
        let showDefaultCard: boolean = (
            !feedbackForm.title
            && !feedbackForm.subtitle
            && !feedbackForm.imageLink
            && !feedbackForm.summary
            && !feedbackForm.checkboxes.length
            && feedbackForm.selectedFeedbackType === FeedbackType.SimpleCompacto
        );

        return showDefaultCard
    };

    private updateFeedbackFormState = (feedbackForm: IFeedbackFormData) => {
        const showDefaultCard: boolean = this.shouldSetDefaultFeedbackCard(feedbackForm);

        this.setState({
            feedbackForm: feedbackForm
        }, () => {
            if (showDefaultCard) {
                feedbackForm.card = this.card.defaultCard();
            }

            this.updateFeedbackCard();
        });
    };

    private onFeedbackTitleChanged = (event: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        feedbackForm.title = event.target.value;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackSubtitleChanged = (event: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        feedbackForm.subtitle = event.target.value;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackImageLinkChanged = (event: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        feedbackForm.imageLink = event.target.value;
        feedbackForm.imageLinkError = this.validateUrl(feedbackForm.imageLink);

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackSummaryChanged = (event: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        feedbackForm.summary = event.target.value;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackRequireCommentsChange = (event: any, checked: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;

        feedbackForm.requireComments = checked.checked;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    }

    private onSelectedFeedbackTypeChange = (item: any) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;

        feedbackForm.selectedFeedbackType = item.key;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackAddCheckbox = () => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        feedbackForm.checkboxes = [...feedbackForm.checkboxes, { id: uuid(), title: "" }];

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackDeleteCheckbox = (id: string) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        const indexToRemove: number = feedbackForm.checkboxes.findIndex(checkbox => checkbox.id === id);

        feedbackForm.checkboxes.splice(indexToRemove, 1);

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };

    private onFeedbackCheckboxTitleChanged = (
        event: any,
        id: string
    ) => {
        const feedbackForm: IFeedbackFormData = this.state.feedbackForm;
        const indexToUpdate: number = feedbackForm.checkboxes.findIndex(button => button.id === id);

        feedbackForm.checkboxes[indexToUpdate].title = event.target.value;

        feedbackForm.card = this.card.rebuildFeedbackCard(feedbackForm);
        this.updateFeedbackFormState(feedbackForm);
    };
    // Feedback

    // Audience
    private audienceGetTeams(): void {
        const audienceForm: IAudienceFormData = this.state.audienceForm;
        audienceForm.teamsLoading = true;
        this.setState({ audienceForm: audienceForm });

        axios.get(`${this.state.userData.organization.id}/teams`)
            .then(response => {
                const teams = response.data

                const audienceForm = this.state.audienceForm;

                audienceForm.teamsLoading = false;

                audienceForm.allTeams = teams.map((team: any) => {
                    return { key: team.aadId, name: team.name, header: team.name, content: "" }
                });

                this.setState({ audienceForm: audienceForm });
            })
            .catch(error => {
                console.log(error);
            });
    };

    private audienceGetUsers(): void {
        const audienceForm: IAudienceFormData = this.state.audienceForm;
        audienceForm.usersLoading = true;
        this.setState({ audienceForm: audienceForm });

        axios.get(`${this.state.userData.organization.id}/users`)
            .then(response => {
                const users = response.data

                const audienceForm = this.state.audienceForm;

                audienceForm.usersLoading = false;

                audienceForm.allUsers = users.map((user: any) => {
                    return { key: user.aadId, name: user.fullName, header: user.fullName, content: "" }
                });

                this.setState({ audienceForm: audienceForm });
            })
            .catch(error => {
                console.log(error);
            });
    };
        private audienceIsSelected(audienceForm: IAudienceFormData): boolean {
        return audienceForm.isAllTargetSelected ||
            (audienceForm.isUsersTargetSelected && audienceForm.selectedUsers.length !== 0) ||
            (audienceForm.isRostersTargetSelected && audienceForm.selectedRosters.length !== 0) ||
            (audienceForm.isTeamsTargetSelected && audienceForm.selectedTeams.length !== 0) ||
            (audienceForm.isGroupTargetSelected && audienceForm.selectedGroup !== '');
    };
    private onAudienceTargetSelectedChange = (event: any, data: any) => {
        const audienceForm: IAudienceFormData = this.state.audienceForm;
        audienceForm.targetSelected = data.value;
        audienceForm.isUsersTargetSelected = data.value === "users";
        audienceForm.selectedUsers = data.value === "users" ? audienceForm.selectedUsers : [];
        audienceForm.isTeamsTargetSelected = data.value === "teams";
        audienceForm.selectedTeams = data.value === "teams" ? audienceForm.selectedTeams : [];
        audienceForm.isRostersTargetSelected = data.value === "rosters";
        audienceForm.selectedRosters = data.value === "roster" ? audienceForm.selectedRosters : [];
        audienceForm.isAllTargetSelected = data.value === "allUsers";
        audienceForm.isGroupTargetSelected = data.value === "groups";
        audienceForm.selectedGroup = data.value === "groups" ? audienceForm.selectedGroup : "";

        this.setState({
            audienceForm: audienceForm
        });
    };

    private onAudienceSelectedUsersChange = (item: any, op: string) => {
        const audienceForm: IAudienceFormData = this.state.audienceForm;

        if (op === "+") {
            audienceForm.selectedUsers = [...this.state.audienceForm.selectedUsers, item];
        } else {
            const indexToRemove: number = audienceForm.selectedUsers.findIndex(dropdownItem => dropdownItem.key === item.key);
            audienceForm.selectedUsers.splice(indexToRemove, 1);
        }

        this.setState({ audienceForm: audienceForm });
    };

    private onAudienceSelectedTeamsChange = (item: any, op: string) => {
        const audienceForm: IAudienceFormData = this.state.audienceForm;

        if (op === "+") {
            audienceForm.selectedTeams = [...this.state.audienceForm.selectedTeams, item];
        } else {
            const indexToRemove: number = audienceForm.selectedTeams.findIndex(dropdownItem => dropdownItem.key === item.key);
            audienceForm.selectedTeams.splice(indexToRemove, 1);
        }

        this.setState({ audienceForm: audienceForm });
    };

    private onAudienceSelectedRostersChange = (item: any, op: string) => {
        const audienceForm: IAudienceFormData = this.state.audienceForm;

        if (op === "+") {
            audienceForm.selectedRosters = [...this.state.audienceForm.selectedRosters, item];
        } else {
            const indexToRemove: number = audienceForm.selectedRosters.findIndex(dropdownItem => dropdownItem.key === item.key);
            audienceForm.selectedRosters.splice(indexToRemove, 1);
        }

        this.setState({ audienceForm: audienceForm });
    };

    private onAudienceSelectedGroupChange = (event: any) => {
        const audienceForm: IAudienceFormData = this.state.audienceForm;
        audienceForm.selectedGroup = event.target.value;

        this.setState({ audienceForm: audienceForm });
    };
    // Audience

    // Wizard
    private renderSwitch(): JSX.Element {
        switch (this.state.step) {
            case 0:
            default:
                return (
                    <Select selectForm={this.state.selectForm}
                        selectedMessageTypeChange={this.onSelectedMessageTypeChange}
                        selectedCardTypeChange={this.onSelectedCardTypeChange} />
                )
            case 1:
                if (this.state.selectForm.selectedMessageType === MessageType.Notification) {
                    return (
                        <NotificationForm notificationForm={this.state.notificationForm}
                            titleChanged={this.onNotificationTitleChanged}
                            subtitleChanged={this.onNotificationSubtitleChanged}
                            imageLinkChanged={this.onNotificationImageLinkChanged}
                            summaryChanged={this.onNotificationSummaryChanged}
                            requireConfirmationChange={this.onNotificationRequireConfirmationChange}
                            requireConfirmationButtonTextChange={this.onNotificationRequireConfirmationButtonTextChange}
                            sendMeetingChange={this.onNotificationSendMeetingChange}
                            selectedMeetingChange={this.onNotificationSelectedMeetingChange}
                            addButtonClick={this.onNotificationAddButtonClick}
                            deleteButtonClick={this.onNotificationDeleteButtonClick}
                            buttonTextChanged={this.onNotificationButtonTextChanged}
                            buttonUrlChanged={this.onNotificationButtonUrlChanged}
                        />
                    )
                } else {
                    return (
                        <FeedbackForm feedbackForm={this.state.feedbackForm}
                            titleChanged={this.onFeedbackTitleChanged}
                            subtitleChanged={this.onFeedbackSubtitleChanged}
                            imageLinkChanged={this.onFeedbackImageLinkChanged}
                            summaryChanged={this.onFeedbackSummaryChanged}
                            requireCommentsChange={this.onFeedbackRequireCommentsChange}
                            selectedFeedbackTypeChange={this.onSelectedFeedbackTypeChange}
                            addCheckbox={this.onFeedbackAddCheckbox}
                            checkboxTitleChanged={this.onFeedbackCheckboxTitleChanged}
                            deleteCheckbox={this.onFeedbackDeleteCheckbox}
                        />
                    )
                }
            case 2:
                return (
                    <AudienceForm
                        audienceForm={this.state.audienceForm}
                        targetSelectedChange={this.onAudienceTargetSelectedChange}
                        selectedUsersChanged={this.onAudienceSelectedUsersChange}
                        selectedTeamsChanged={this.onAudienceSelectedTeamsChange}
                        selectedRostersChanged={this.onAudienceSelectedRostersChange}
                        selectedGroupChanged={this.onAudienceSelectedGroupChange}
                    />
                )
            case 3:
                return (
                    <CongratulationForm />
                )
        }
    };

    render() {
        return (
            <div className="taskModule">
                <Flex className="formContainer"
                    column
                    vAlign="stretch"
                    gap="gap.small"
                    styles={{ background: "white" }}
                >
                    {this.renderSwitch()}
                    <Flex className="footerContainer" vAlign="end" hAlign="end" space="between">
                        <Text>TeamyComm Versión: {this.state.version}</Text>

                        <Flex className="buttonContainer" gap="gap.small" >
                            <Button content="Volver"
                                disabled={this.isPreviousButtonDisable()}
                                hidden={!this.isNewMessageHidden()}
                                id="previousButton"
                                onClick={() => this.onPreviousClick()}
                                primary
                            />
                            <Button content="Siguiente"
                                disabled={this.isNextButtonDisable()}
                                hidden={!this.isNewMessageHidden()}
                                id="nextButton"
                                onClick={() => this.onNextClick()}
                                primary
                            />
                            <Button content="Enviar"
                                disabled={this.isSendButtonDisable()}
                                hidden={!this.isNewMessageHidden()}
                                id="nextButton"
                                onClick={() => this.onSendClick()}
                                primary
                            />
                            <Button content="Nuevo mensaje"
                                hidden={this.isNewMessageHidden()}
                                id="nextButton"
                                onClick={() => this.onNewMessageClick()}
                                primary
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </div>
        )
    };

    private isNextButtonDisable(): boolean {
        let defaultCard: boolean = true;

        if (this.state.selectForm.selectedMessageType === MessageType.Notification) {
            defaultCard = this.shouldSetDefaultNotificationCard(this.state.notificationForm);
        } else {
            defaultCard = this.shouldSetDefaultFeedbackCard(this.state.feedbackForm);
        }

        return this.state.step > 1 ||
            (this.state.step === 1 && defaultCard);
    };

    private isPreviousButtonDisable(): boolean {
        return this.state.step < 1;
    };

    private isSendButtonDisable(): boolean {
        let audienceSelected: boolean = false;

        audienceSelected = this.audienceIsSelected(this.state.audienceForm);

        return this.state.step < 2 ||
            (this.state.step === 2 && !audienceSelected)
    };

    private isNewMessageHidden(): boolean {
        return this.state.step < 3;
    }

    private onPreviousClick(): void {
        const step: number = this.state.step - 1;
        this.setState({ step: step }, () => {
            switch (step) {
                case 0:
                    this.resetForm();
                    break;
                case 1:
                    if (this.state.selectForm.selectedMessageType === MessageType.Notification) {
                        // this.updateNotificationCardStatus(this.state.notificationForm);
                        this.updateNotificationFormState(this.state.notificationForm);
                    } else {
                        // this.card.rebuildCard(this.state.feedbackForm);
                        this.updateFeedbackFormState(this.state.feedbackForm);
                    }
                    break;
                default:
                    break;
            }
        });
    };

    private onNextClick(): void {
        const step: number = this.state.step + 1;

        this.setState({ step: step }, () => {
            switch (step) {
                case 1:
                    if (this.state.selectForm.selectedMessageType === MessageType.Notification) {
                        // this.updateNotificationCardStatus(this.state.notificationForm);
                        this.updateNotificationFormState(this.state.notificationForm);
                    } else {
                        // this.card.rebuildCard(this.state.feedbackForm);
                        this.updateFeedbackFormState(this.state.feedbackForm);
                    }
                    break;
                case 2:
                    this.audienceGetUsers();
                    this.audienceGetTeams();
                    break;
                default:
                    break;
            }
        });
    };

    private onSendClick(): void {
        if (this.state.audienceForm.targetSelected === "users") {
            this.sendToUsers();
        }

        if (this.state.audienceForm.targetSelected === "allUsers") {
            this.sendToAllUsers();
        }

        if (this.state.audienceForm.targetSelected === "teams") {
            this.sendToTeams();
        }

        if (this.state.audienceForm.targetSelected === "rosters") {
            this.sendToRoster();
        }

        if (this.state.audienceForm.targetSelected === "groups") {
            this.sendToGroup();
        }

        const step: number = this.state.step + 1;

        this.setState({ step: step });
    };

    private onNewMessageClick(): void {
        this.resetForm();
    }

    private sendToUsers(): void {
        axios.post("/cardnotification/sendtousers", {
            "tenant": this.state.userData.organization.id,
            "Users": this.state.audienceForm.selectedUsers.map((item: any) => {
                return { "aadId": item.key, "fullName": item.name }
            }),
            // "Id": uuid(),
            "Id": this.card.getId(),
            "Type": this.state.selectForm.selectedMessageType,
            "Card": JSON.stringify(this.state.selectForm.selectedMessageType === MessageType.Notification ?
                this.state.notificationForm.card : this.state.feedbackForm.card),
            "RequiereMeeting": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.sendMeeting.valueOf() : "false",
            
            "RequiereConfirmation": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.requireConfirmation.valueOf() : "false",
            "Creator": this.state.userData.profile.id,
            "Title": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.title.valueOf() : this.state.feedbackForm.title.valueOf(),
            "SubTitle": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.subtitle.valueOf() : this.state.feedbackForm.subtitle.valueOf()
        })
            .then(response => {
                console.log(response);
            });
    };

    private sendToAllUsers(): void {
        axios.post("/cardnotification/sendtoallusers", {
            "tenant": this.state.userData.organization.id,
            // "Id": uuid(),
            "Id": this.card.getId(),
            "Type": this.state.selectForm.selectedMessageType,
            "Card": JSON.stringify(this.state.selectForm.selectedMessageType === MessageType.Notification ?
                this.state.notificationForm.card : this.state.feedbackForm.card),
            "RequiereMeeting": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.sendMeeting.valueOf() : "false",
            "RequiereConfirmation": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.requireConfirmation.valueOf() : "false",
            "Creator": this.state.userData.profile.id,
            "Title": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.title.valueOf() : this.state.feedbackForm.title.valueOf(),
            "SubTitle": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.subtitle.valueOf() : this.state.feedbackForm.subtitle.valueOf()
        })
            .then(response => {
                console.log(response);
            });
    };

    private sendToTeams(): void {
        axios.post("/cardnotification/sendtoteams", {
            "tenant": this.state.userData.organization.id,
            "Teams": this.state.audienceForm.selectedTeams.map((item: any) => {
                return { "aadId": item.key, "name": item.name }
            }),
            // "Id": uuid(),
            "Id": this.card.getId(),
            "Type": this.state.selectForm.selectedMessageType,
            "Card": JSON.stringify(this.state.selectForm.selectedMessageType === MessageType.Notification ?
                this.state.notificationForm.card : this.state.feedbackForm.card),
            "RequiereMeeting": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.sendMeeting.valueOf() : "false",
            "RequiereConfirmation": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.requireConfirmation.valueOf() : "false",
            "Creator": this.state.userData.profile.id,
            "Title": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.title.valueOf() : this.state.feedbackForm.title.valueOf(),
            "SubTitle": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.subtitle.valueOf() : this.state.feedbackForm.subtitle.valueOf()
        })
            .then(response => {
                console.log(response);
            });
    };

    private sendToRoster(): void {
        axios.post("/cardnotification/sendtorosters", {
            "tenant": this.state.userData.organization.id,
            "teams": this.state.audienceForm.selectedRosters.map((item: any) => {
                return { "aadId": item.key, "name": item.name }
            }),
            // "Id": uuid(),
            "Id": this.card.getId(),
            "Type": this.state.selectForm.selectedMessageType,
            "Card": JSON.stringify(this.state.selectForm.selectedMessageType === MessageType.Notification ?
                this.state.notificationForm.card : this.state.feedbackForm.card),
            "RequiereMeeting": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.sendMeeting.valueOf() : "false",
            "RequiereConfirmation": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.requireConfirmation.valueOf() : "false",
            "Creator": this.state.userData.profile.id,
            "Title": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.title.valueOf() : this.state.feedbackForm.title.valueOf(),
            "SubTitle": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.subtitle.valueOf() : this.state.feedbackForm.subtitle.valueOf()
        })
            .then(response => {
                console.log(response);
            });
    };

    private sendToGroup(): void {
        axios.post("/cardnotification/sendtogroup", {
            "tenant": this.state.userData.organization.id,
            "group": this.state.audienceForm.selectedGroup,
            // "Id": uuid(),
            "Id": this.card.getId(),
            "Type": this.state.selectForm.selectedMessageType,
            "Card": JSON.stringify(this.state.selectForm.selectedMessageType === MessageType.Notification ?
                this.state.notificationForm.card : this.state.feedbackForm.card),
            "RequiereMeeting": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.sendMeeting.valueOf() : "false",
            "RequiereConfirmation": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.requireConfirmation.valueOf() : "false",
            "Creator": this.state.userData.profile.id,
            "Title": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.title.valueOf() : this.state.feedbackForm.title.valueOf(),
            "SubTitle": this.state.selectForm.selectedMessageType === MessageType.Notification ? this.state.notificationForm.subtitle.valueOf() : this.state.feedbackForm.subtitle.valueOf()
        })
            .then(response => {
                console.log(response);
            });
    };
    // Wizard
}
